import { render, staticRenderFns } from "./civil.vue?vue&type=template&id=42eaa87b&scoped=true&"
import script from "./civil.vue?vue&type=script&lang=js&"
export * from "./civil.vue?vue&type=script&lang=js&"
import style0 from "./civil.vue?vue&type=style&index=0&id=42eaa87b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eaa87b",
  null
  
)

export default component.exports